module.exports = __webpack_public_path__ + "media/Video 156b.32ff3709.mp4";